import type { AnalyticsInstance } from 'analytics'
import { useRef } from 'react'

import { getAnalyticsInstance } from './singleton'

export const useAnalyticsInstanceRef = () => {
  return useRef<AnalyticsInstance>(getAnalyticsInstance())
}
